<template>
  <div id="ai-component-refactored" class="ai-container">
    <!-- Logged in users -->
    <div v-if="hasArtificialIntelligenceAccess">
      <!-- Users with AI access -->
      <div>
        <PageHeader 
          title="Inteligencia Artificial" 
          titleClass="ai-title"
          subtitleClass="ai-text">
          Utiliza esta herramienta para que la máquina de eurekers te muestre tu compatibilidad de inversión con los valores seleccionados según tus preferencias.
        </PageHeader>

        <!-- Loading view -->
        <div v-if="isLoading" class="loading-panel">
          <div class="loading-content">
            <div class="loading-spinner"></div>
            <h4 class="loading-title">Cargando datos...</h4>
            <p class="loading-description">Estamos obteniendo tu información de compatibilidad. Esto puede tomar unos momentos.</p>
          </div>
        </div>

        <!-- Results view: when user has completed test and data is loaded -->
        <div v-else-if="test_do_it === true" class="ai-content">
          <div class="actions-panel">
            <div class="action-buttons">
              <a :href="test_redirect" class="action-link">
                <button class="ia-action-btn ia-action-btn--primary">{{ buttonText }}</button>
              </a>
              <button 
                @click="_redirectToStockchart" 
                class="ia-action-btn ia-action-btn--secondary"
              >
                {{ button_name_stockchart }}
              </button>
            </div>
            
            <div v-if="_g_UserFeatures.permissions.adaptative_artificial_inteligence" class="ai-toggle">
              <label class="switch">
                <input type="checkbox" v-model="adaptative" @change="_handleAdaptativeChange" :disabled="isToggleLoading" />
                <span class="slider" :class="{ 'slider--disabled': isToggleLoading }"></span>
              </label>
              <span class="toggle-label">{{ checkbox_label_name }}</span>
              <div v-if="isToggleLoading" class="toggle-spinner"></div>
            </div>
          </div>

          <!-- Table loading for toggle changes -->
          <div v-if="isToggleLoading" class="tables-loading">
            <div class="loading-content">
              <div class="loading-spinner loading-spinner--small"></div>
              <p class="loading-description">Actualizando tablas...</p>
            </div>
          </div>

          <!-- Tables -->
          <div v-else class="results-panel">
            <div class="table-section">
              <h4 class="section-title">Valores en Europa</h4>
              <Table :table_header="table_header" :table_body="table_body_eu" class="ai-table"/>
            </div>
            <div class="table-section">
              <h4 class="section-title">Valores en USA</h4>
              <Table :table_header="table_header" :table_body="table_body_usa" class="ai-table"/>
            </div>
            <div class="table-section">
              <h4 class="section-title">Valores en Resto del mundo</h4>
              <Table :table_header="table_header" :table_body="table_body_rest" class="ai-table"/>
            </div>
          </div>
        </div>

        <!-- No results view: when user hasn't completed test -->
        <div v-else-if="test_do_it === false" class="no-results-panel">
          <div class="empty-state">
            <h4 class="empty-title">No hay datos disponibles</h4>
            <p class="empty-description">
              No tienes datos en las tablas de resultados. Realiza el test para que la máquina de eurekers te muestre tu compatibilidad de inversión con los valores disponibles.
            </p>
            <button @click="_go_to_start_test" class="ia-action-btn ia-action-btn--primary">
              Realizar test
            </button>
          </div>

          <!-- Test preparation view -->
          <div v-if="btn_test_pressed" class="test-preparation">
            <div class="test-info">
              <h4 class="test-title">Test de Compatibilidad</h4>
              <div class="test-description">
                <p class="test-duration"><strong>La duración estimada de este test es de unos 20 minutos.</strong></p>
                <p class="test-instructions">
                  Vas a empezar el test de compatibilidad. Deberás evaluar las gráficas entre 1 y 5 puntos.
                  Para que tu perfil de compatibilidad sea más preciso, necesitamos que seas riguroso con tus respuestas.
                  Tómate tu tiempo evaluando cada entrada y decide en qué grado te gusta o no te gusta cada una.
                </p>
              </div>
              <a :href="test_redirect" class="action-link">
                <button class="ia-action-btn ia-action-btn--primary ia-action-btn--large">
                  {{ button_start_test }}
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>

    </div>

    <ToolAccessState
      v-else-if="_g_HasAppSession"
      title="Inteligencia artificial no incluida"
      message="Tu plan actual no incluye acceso a esta herramienta."
    />

    <!-- Not logged in users -->
    <ToolAccessState
      v-else
      title="Inteligencia artificial adaptativa"
      message="Inicia sesión para acceder a inteligencia artificial adaptativa."
      anonymous
    />
  </div>
</template>

<script>
  import Table from '@/components/helpers/Table_ia.vue';
  import APICaller from "@/components/codeComponents/APICaller.js";
  import PageHeader from "@/components/common/PageHeader.vue";
  import ToolAccessState from "@/components/common/ToolAccessState.vue";
  import Highcharts from "highcharts";
  import { mapGetters } from "vuex";


  export default {
    mixins: [APICaller],
    name: 'InteligenceArtificial',
    components: {
      Table,
      PageHeader,
      ToolAccessState
    },
   
    data() {
      return {
        table_header: [],
        table_body_eu: [],
        table_body_usa: [],
        table_body_rest: [],

        button_name_test: 'REALIZAR TEST',
        button_start_test: 'Comenzar test',
        button_key_test: 'ia_button_test',

        button_name_stockchart: 'Ver todos en el Graficador Dinámico',
        button_key_stockchart: 'ia_button_stockchart',
        button_icon: '',
        
        checkbox_key: 'ia_checkbox_apply',
        checkbox_id: 'ia_checkbox_apply',
        checkbox_state: true,
        checkbox_label_name: ' Aplicar IA adaptativa',
        user_uid: '',
        user_feature: '',
        adaptative:true,
        test_do_it: null,
        isLoading: false,
        isToggleLoading: false,

        btn_test_pressed: false,
        
        test_redirect: process.env.VUE_APP_API + '/test-graficos-potenciales',
        retryTimeoutId: null,
      };
    },
    created(){     
      if (!this.hasArtificialIntelligenceAccess) {
        return;
      }

      this.isLoading = true;
      this.$nextTick(() => {
        this._user_ia_tables();
        setTimeout(() => {
          this._user_ia_tables();
        }, 500);
        this._startRetryTimeout();
      });
    },
    mounted() {
      //this._addImageToTable();
    },
    beforeDestroy() {
      // Clean up timeout when component is destroyed
      if (this.retryTimeoutId) {
        clearTimeout(this.retryTimeoutId);
        this.retryTimeoutId = null;
      }
    },
    updated() {           
      // HTML processing now handled in data preparation
    }, 
    computed:{
      //this._addImageToTable();
      ...mapGetters(["_g_HasAppSession"]),
      ...mapGetters(['is_mobile_device']),                                                                                                 
      ...mapGetters(['_g_User']),
      ...mapGetters(["_g_UserFeatures"]),
      hasArtificialIntelligenceAccess() {
        const permissions = (this._g_UserFeatures && this._g_UserFeatures.permissions) || {};
        return permissions.artificial_inteligence === true;
      },
      
      // Dynamic button text based on test completion status
      buttonText() {
        return this.test_do_it === true ? 'REALIZAR TEST OTRA VEZ' : 'REALIZAR TEST';
      }
    },
    methods: {
      _startRetryTimeout() {
        // Clear any existing timeout
        if (this.retryTimeoutId) {
          clearTimeout(this.retryTimeoutId);
        }
        
        // Set 10 second timeout to check if data is populated
        this.retryTimeoutId = setTimeout(() => {
          // Check if any of the table bodies have data
          if (this.table_body_eu.length === 0 && 
              this.table_body_usa.length === 0 && 
              this.table_body_rest.length === 0) {
            // Data is still empty, retry the API call
            this._user_ia_tables();
            this._startRetryTimeout(); // Restart the timeout
          }
        }, 10000); // 10 seconds
      },
      
      _redirectToLogin() {
        window.location.href = "/user/login"; // Reemplaza la URL con la que desees redirigir
      },
      _handleAdaptativeChange() {
        this.isToggleLoading = true;
        this.table_body_eu = [];
        this.table_body_rest = [];
        this.table_body_usa = [];
        
        // Clear any existing retry timeout when toggling
        if (this.retryTimeoutId) {
          clearTimeout(this.retryTimeoutId);
          this.retryTimeoutId = null;
        }
        
        this.$nextTick(() => {
          this._user_ia_tables();
        });
      },
      _redirectToStockchart() {
        this.$router.push('/app/graficador-dinamico/compatibility')
      },
      _user_ia_tables(){  
        let success = (response) => {
          this.table_header = [],
          this.table_body_eu = [],
          this.table_body_usa = [],
          this.table_body_rest = [],
          this.isLoading = false;
          this.isToggleLoading = false;
          
          if(response.data[0].rows.length == 0){
            this.test_do_it = false;
          }else{
            this.test_do_it = true;
            this._data_load_in_tables(response.data,0);
            this._tableHeader(response.data,0);
            this._data_load_in_tables(response.data,1);
            this._data_load_in_tables(response.data,2);
          }
          
          // Clear the retry timeout since we got a successful response
          if (this.retryTimeoutId) {
            clearTimeout(this.retryTimeoutId);
            this.retryTimeoutId = null;
          }
        };

        let failure = () => {
          this.isLoading = false;
          this.isToggleLoading = false;
          this.test_do_it = false;
          
          // Don't clear the retry timeout on failure - let it continue retrying
        };

        let url = "/api/v1/compatibility/tables/" + this.adaptative;

        const successHandler = new APICaller.SuccessHandler(success);
        const failureHandler = new APICaller.FailureHandler('187', 'Error recuperando tablas.', failure);

        this._getAPICall(url, successHandler, failureHandler);
      },
      _tableHeader(data,value){
        this.table_header = [];      
        var json = data[value].header;
        for(var i=1;i<=Object.keys(json).length;i++){
          this.table_header.push(json[i]["data"]);
        }
        
      },
      _data_load_in_tables(data,tabla){       
        var json = data[tabla].rows;     
        for(var i=1;i<=Object.keys(json).length;i++){          
          if(this.adaptative){
            // Process status to show proper icons
            let statusDisplay = json[i]["status"]["data"];
            if(statusDisplay === "arrow-down-red"){
              statusDisplay = "<div class='material-icons-outlined red'>arrow_downward</div>";
            } else if(statusDisplay === "arrow-up-green"){
              statusDisplay = "<div class='material-icons-outlined green'>arrow_upward</div>";
            }
            
            // Process graph HTML content
            let graphDisplay = json[i]["graph"];
            if(graphDisplay && graphDisplay.includes("&lt;") && graphDisplay.includes("&gt;")){
              graphDisplay = graphDisplay.replace(/&lt;/g, '<').replace(/&gt;/g, '>');
            }
            
            var elemento1 = [
              json[i]["position"],
              json[i]["ticker_info"]["ticker"],
              graphDisplay,
              json[i]["entry_type"],
              (json[i]["compatibility"]["data"]*100).toFixed(2) + "%",
              json[i]["modifier_value"]["data"].toFixed(2) + "%",                       
              statusDisplay,
            ];
            if(tabla == 0){
              this.table_body_eu.push(elemento1);
            }else if(tabla == 1){
              this.table_body_rest.push(elemento1);
            }else{
              this.table_body_usa.push(elemento1);
            }
          }else{
            // Process status to show proper icons
            let statusDisplay = json[i]["status"]["data"];
            if(statusDisplay === "arrow-down-red"){
              statusDisplay = "<div class='material-icons-outlined red'>arrow_downward</div>";
            } else if(statusDisplay === "arrow-up-green"){
              statusDisplay = "<div class='material-icons-outlined green'>arrow_upward</div>";
            }
            
            // Process graph HTML content
            let graphDisplay = json[i]["graph"];
            if(graphDisplay && graphDisplay.includes("&lt;") && graphDisplay.includes("&gt;")){
              graphDisplay = graphDisplay.replace(/&lt;/g, '<').replace(/&gt;/g, '>');
            }
            
            var elemento = [
              json[i]["position"],
              json[i]["ticker_info"]["ticker"],
              graphDisplay,
              json[i]["entry_type"],
              (json[i]["compatibility"]["data"]*100).toFixed(2) + "%",           
              statusDisplay,
            ];
            if(tabla == 0){
              this.table_body_eu.push(elemento);
            }else if(tabla == 1){
              this.table_body_rest.push(elemento);
            }else{
              this.table_body_usa.push(elemento);
            }
          }
      } 
      },     

      _add_graph(id,value,ticker) {
        var ide = id;
        var valuee = value;
        Highcharts.chart(ide, {
        chart: {
            plotBackgroundColor: null,
            plotBorderWidth: 0,
            plotShadow: false
        },
        title: {
            text: valuee + "%",
            align: 'center',
            verticalAlign: 'middle',
            y: 20,
            style: {
              fontSize: '12px'
            }
        },
        tooltip: {
            pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
        },
        accessibility: {
            point: {
                valueSuffix: '%'
            }
        },
        plotOptions: {
            pie: {
                dataLabels: {
                    enabled: true,
                    distance: -50,
                    style: {
                        fontWeight: 'bold',
                        color: 'white'
                    }
                },
                startAngle: -90,
                endAngle: 90,
                center: ['50%', '75%'],
                size: '110%'
            }
        },
        series: [{
            type: 'pie',
            name: ticker,
            innerSize: '50%',
            data: [
                ['', valuee],
                {
                    name: 'Other',
                    y: 100-valuee,
                    dataLabels: {
                        enabled: false
                    }
                }
            ]
          }]
        });
          
      },
      _go_to_start_test(){
        this.btn_test_pressed = true;
      }
  }
}
</script>


<style lang="scss" scoped>
.ai-container {
  background-color: var(--color-background);
  color: var(--color-text-primary);
  padding: 20px 5%;
  min-height: 100vh;
  max-width: 1200px;
  margin: 0px auto;
  box-sizing: border-box;
}

.ai-title {
  font-size: 2.125rem;
  font-weight: 500;
  line-height: 1.2;
}

.ai-text {
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.6;
}

// Card-based panels
.actions-panel,
.results-panel,
.no-results-panel,
.access-denied-panel,
.login-required-panel {
  background-color: var(--color-surface);
  border-radius: 12px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.07);
  padding: 30px;
  margin-bottom: 40px;
  border: 1px solid var(--color-outline);
}

.actions-panel {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 30px;
}

.action-buttons {
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
}

.ia-action-btn {
  padding: 12px 24px;
  border: none;
  border-radius: 25px;
  font-size: 0.875rem;
  font-weight: 500;
  text-transform: uppercase;
  cursor: pointer;
  transition: all 0.2s ease;
  text-decoration: none;
  display: inline-block;
  
  &--primary {
    background-color: var(--color-highlight);
    color: var(--color-text-on-highlight, white);
    
    &:hover {
      background-color: var(--color-highlight);
      opacity: 0.9;
      transform: translateY(-1px);
    }
  }
  
  &--secondary {
    background-color: var(--color-surface);
    color: var(--color-text-primary);
    border: 1px solid var(--color-outline);
    
    &:hover {
      background-color: var(--color-active-surface);
      border-color: var(--color-highlight);
      color: var(--color-highlight);
    }
  }
  
  &--large {
    padding: 15px 30px;
    font-size: 1rem;
  }
}

.action-link {
  text-decoration: none;
}

// Toggle switch (similar to Risk.vue)
.ai-toggle {
  display: flex;
  align-items: center;
  gap: 10px;
  
  .toggle-label {
    color: var(--color-text-primary);
    font-size: 0.875rem;
  }
  
  .switch {
    position: relative;
    display: inline-block;
    width: 50px;
    height: 28px;
    
    input {
      opacity: 0;
      width: 0;
      height: 0;
    }
  }
  
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: var(--color-muted, #ccc);
    transition: .4s;
    border-radius: 28px;
    
    &:before {
      position: absolute;
      content: "";
      height: 20px;
      width: 20px;
      left: 4px;
      bottom: 4px;
      background-color: var(--color-text-on-highlight, white);
      transition: .4s;
      border-radius: 50%;
    }
  }
  
  input:checked + .slider {
    background-color: var(--color-highlight);
  }
  
  input:checked + .slider:before {
    transform: translateX(22px);
  }
}

// Results panel - stacked layout
.results-panel {
  display: flex;
  flex-direction: column;
  gap: 30px;
  padding: 0;
  background: none;
  box-shadow: none;
  border: none;
}

.table-section {
  background-color: var(--color-surface);
  border-radius: 16px;
  padding: 35px;
  border: 1px solid var(--color-outline);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  transition: all 0.2s ease;
  
  &:hover {
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.12);
    transform: translateY(-2px);
  }
}

.section-title {
  font-size: 1.375rem;
  font-weight: 700;
  color: var(--color-text-primary);
  margin-bottom: 25px;
  margin-top: 0;
  padding-bottom: 15px;
  border-bottom: 2px solid var(--color-highlight);
  display: flex;
  align-items: center;
  
  &::before {
    content: '';
    width: 6px;
    height: 24px;
    background-color: var(--color-highlight);
    margin-right: 12px;
    border-radius: 3px;
  }
}

.ai-table {
  width: 100%;
  margin: 0;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

// Empty state
.empty-state {
  text-align: center;
  padding: 40px 20px;
}

.empty-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--color-text-primary);
  margin-bottom: 15px;
  margin-top: 0;
}

.empty-description {
  font-size: 1rem;
  color: var(--color-text-secondary);
  line-height: 1.6;
  margin-bottom: 30px;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

// Test preparation
.test-preparation {
  margin-top: 30px;
  padding: 30px;
  background-color: var(--color-active-surface);
  border-radius: 12px;
  border: 1px solid var(--color-outline);
}

.test-info {
  text-align: center;
}

.test-title {
  font-size: 1.375rem;
  font-weight: 600;
  color: var(--color-text-primary);
  margin-bottom: 20px;
  margin-top: 0;
}

.test-description {
  margin-bottom: 30px;
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
}

.test-duration {
  font-size: 1.125rem;
  color: var(--color-text-primary);
  margin-bottom: 15px;
}

.test-instructions {
  font-size: 1rem;
  color: var(--color-text-secondary);
  line-height: 1.6;
  margin-bottom: 0;
}

// Access denied
.access-denied-panel {
  text-align: center;
  padding: 50px 30px;
}

.access-denied-title {
  font-size: 1.5rem;
  font-weight: bold;
  color: #FF9B00;
  margin-bottom: 15px;
}

.access-denied-text {
  font-size: 1rem;
  color: var(--color-text-secondary);
}

.upgrade-link {
  color: var(--color-highlight);
  text-decoration: none;
  
  &:hover {
    text-decoration: underline;
  }
}

// Login required / Feature showcase
.login-required-panel {
  padding: 0;
  background: none;
  box-shadow: none;
  border: none;
}

.feature-showcase {
  background-color: var(--color-surface);
  border-radius: 12px;
  padding: 40px;
  border: 1px solid var(--color-outline);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.07);
}

.showcase-content {
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
}

.showcase-image {
  max-width: 500px;
  width: 100%;
  height: auto;
  border-radius: 12px;
  margin-bottom: 30px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.showcase-title {
  font-size: 2rem;
  font-weight: 600;
  color: var(--color-text-primary);
  margin-bottom: 20px;
}

.showcase-description {
  font-size: 1rem;
  color: var(--color-text-secondary);
  line-height: 1.6;
  text-align: justify;
  margin-bottom: 30px;
}

.login-btn {
  background-color: var(--color-highlight);
  color: var(--color-text-on-highlight, white);
  border: none;
  border-radius: 25px;
  padding: 12px 30px;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  text-transform: uppercase;
  
  &:hover {
    opacity: 0.9;
    transform: translateY(-1px);
  }
}

.unauthorized {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  text-align: center;
  font-size: 1.125rem;
  color: var(--color-text-secondary);
  background-color: var(--color-surface);
  border-radius: 12px;
  padding: 40px;
  border: 1px solid var(--color-outline);
}

// Highcharts styles (keeping existing functionality)
.highcharts-credits {
  display: none !important;
}

th {
  height: 90px !important;
}

// Loading states
.loading-panel,
.tables-loading {
  background-color: var(--color-surface);
  border-radius: 12px;
  padding: 50px 30px;
  margin-bottom: 40px;
  border: 1px solid var(--color-outline);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.07);
}

.loading-content {
  text-align: center;
}

.loading-spinner {
  width: 48px;
  height: 48px;
  border: 4px solid var(--color-outline);
  border-top: 4px solid var(--color-highlight);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 20px;
  
  &--small {
    width: 32px;
    height: 32px;
    border-width: 3px;
    margin-bottom: 15px;
  }
}

.toggle-spinner {
  width: 16px;
  height: 16px;
  border: 2px solid var(--color-outline);
  border-top: 2px solid var(--color-highlight);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-left: 10px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--color-text-primary);
  margin-bottom: 10px;
  margin-top: 0;
}

.loading-description {
  font-size: 1rem;
  color: var(--color-text-secondary);
  margin: 0;
}

.slider--disabled {
  opacity: 0.6;
  pointer-events: none;
}

.tables-loading {
  padding: 30px;
  margin: 20px 0;
}

// Responsive design
@media (max-width: 768px) {
  .ai-container {
    padding: 20px;
  }
  
  .actions-panel {
    flex-direction: column;
    align-items: stretch;
    gap: 15px;
  }
  
  .action-buttons {
    justify-content: center;
  }
  
  .ai-toggle {
    justify-content: center;
  }
  
  .table-section {
    padding: 25px 20px;
  }
  
  .section-title {
    font-size: 1.25rem;
    margin-bottom: 20px;
    padding-bottom: 12px;
    
    &::before {
      width: 5px;
      height: 20px;
      margin-right: 10px;
    }
  }
  
  .test-preparation,
  .feature-showcase,
  .actions-panel,
  .no-results-panel,
  .access-denied-panel,
  .loading-panel {
    padding: 25px;
    margin-bottom: 30px;
  }
  
  .showcase-image {
    max-width: 100%;
  }
  
  .test-description,
  .empty-description,
  .showcase-description {
    text-align: left;
  }
  
  .loading-spinner {
    width: 40px;
    height: 40px;
    
    &--small {
      width: 28px;
      height: 28px;
    }
  }
}

@media (max-width: 480px) {
  .ai-title {
    font-size: 1.75rem;
  }
  
  .ai-text {
    font-size: 0.9rem;
  }
  
  .ia-action-btn {
    padding: 10px 20px;
    font-size: 0.8125rem;
    
    &--large {
      padding: 12px 25px;
      font-size: 0.875rem;
    }
  }
  
  .showcase-title {
    font-size: 1.5rem;
  }
  
  .section-title {
    font-size: 1rem;
  }
  
  .empty-title {
    font-size: 1.25rem;
  }
  
  .test-title {
    font-size: 1.125rem;
  }
}
</style>
